import type { FaireAdvertiserProfileEntity } from "../../entity_types/advertiserProfile";

// Strange Water (b_bs87t4kkpd, advertiser 2560535894220628738).
// Lifetime complete-month metrics through Aug 2026.
export const advStrangeWater: FaireAdvertiserProfileEntity = {
  token: "adv_strange_water",
  type: "advertiserProfile",
  archetype: "new-and-returning",
  displayName: "Strange Water",
  brandToken: "b_bs87t4kkpd",
  audienceType: "NEW_AND_RETURNING",
  globalStatus: "ACTIVE",
  tenureMonths: 4,
  budget: {
    totalBudgetDollars: 1000,
    sharedBudgetDollars: 1000,
    spendingMode: "COMPETITIVE",
    nextRenewsAtDate: "2026-10-01",
    nextBillsAtDate: "2026-10-04",
  },
  overview: {
    numCustomersAcquired: 15,
    numReorderConversions: 14,
    numTotalConversions: 29,
    totalAdsSalesDollars: 4671,
    newCustomerAdsSalesDollars: 2282,
    reorderAdsSalesDollars: 2389,
    totalAdsSpendDollars: 866,
    newCustomerAdsSpendDollars: 697,
    reorderAdsSpendDollars: 169,
    newCustomerBestEstimateFirstYearRoas: 4.95,
    reorderRoas: 14.14,
    combinedFirstYearRoas: 6.74,
    numNewCustomerAdsOrders: 33,
    numReorderAdsOrders: 22,
  },
  availableCredit: { totalRemainingDollars: 0 },
  budgetRecommendations: {
    newCustomer: {
      minRecommendedBudgetDollars: 480,
      maxRecommendedBudgetDollars: 960,
      isEligibleForIncreaseRec: false,
    },
    reorder: {
      minRecommendedBudgetDollars: 100,
      maxRecommendedBudgetDollars: 200,
      isEligibleForIncreaseRec: false,
    },
  },
  campaignTokens: ["camp_sw_new", "camp_sw_reorder"],
  overviewPerformancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-29T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
